import { version } from './version';

export const environment = {
  production: true,
  baseUrl: '',
  sentryPublicDSN: 'https://ac471ee3b1ef4d1f884bfeaebaf6d007@sentry.inspirehep.net/7',
  version
};



// WEBPACK FOOTER //
// /home/travis/build/inspirehep/record-editor/src/environments/environment.ts